<template>
  <div class="space-capacity">
    <div :class="['space-capacity__bar']">
      <span :class="['space-capacity__label']">{{ t("capacity") }}:</span>

      <div
        :class="[
          'space-capacity__row',
          'space-capacity__capacity',
          isCapacity(CapacityStatus.RESERVED) && 'space-capacity__capacity--success'
        ]"
      >
        <img v-if="isCapacity(CapacityStatus.RESERVED)" :src="CapacitySuccessIcon" alt="Capacity Reserved" />

        <img v-else :src="CapacityWarningIcon" alt="Not all capacity reserved" />

        <span>{{ capacityLabel }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { WorkspaceTemplate } from "@/types/workspace"
import { computed, defineComponent, PropType } from "@vue/composition-api"
import { createTranslationModule } from "@/plugins/i18n"
import CapacitySuccessIcon from "@/assets/cloud-success.svg"
import CapacityWarningIcon from "@/assets/cloud-warning.svg"
import "../../scss/_space-capacity.scss"

enum CapacityStatus {
  ON_DEMAND = "on-demand",
  RESERVED = "reserved",
  PARTIAL_RESERVED = "partial-reserved"
}

export default defineComponent({
  name: "CapacityReservation",
  props: {
    workspace: {
      type: Object as PropType<WorkspaceTemplate>,
      required: true
    }
  },
  setup(props) {
    const t = createTranslationModule("WorkspaceEdit.appCard.footer.capacityReservation")

    const capacityStatus = computed(() => {
      const apps = props.workspace.schema.assets
      const reserved = apps.filter(a => a.capacityReservation && a.capacityReservation.endDate)

      if (reserved.length > 0) {
        if (reserved.length === apps.length) {
          return CapacityStatus.RESERVED
        } else {
          return CapacityStatus.PARTIAL_RESERVED
        }
      }

      return CapacityStatus.ON_DEMAND
    })

    const isCapacity = (status: CapacityStatus) => {
      return capacityStatus.value === status
    }

    const capacityLabel = computed(() => {
      if (isCapacity(CapacityStatus.PARTIAL_RESERVED)) {
        return t("partial")
      } else if (isCapacity(CapacityStatus.RESERVED)) {
        return t("reserved")
      } else {
        return t("onDemand")
      }
    })

    return {
      t,
      CapacityStatus,
      isCapacity,
      capacityLabel,
      capacityStatus,
      CapacitySuccessIcon,
      CapacityWarningIcon
    }
  }
})
</script>
